module.exports = __webpack_public_path__ + "img/gas.15b3a93e.svg";